document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.--custom-fb-coupon-ticket').forEach(el => {
    el.addEventListener('click', () => {
      let next = el.nextElementSibling;
      while (next) {
        if (next.tagName === 'A' || next.tagName === 'BUTTON') {
          next.click();
          break;
        }
        next = next.nextElementSibling;
      }
    });
  });
});